import React, { useCallback, useState } from 'react'
import { hooks, I18n, Section } from '@front/volcanion'

import { Box, Collapse, Typography, Divider, Icon, Badge } from '@mui/material'

import QuickSection from './Section/Quick'
import B2BSection from './Section/B2B'
import TransportSection from './Section/Transport'
import BillingSection from './Section/Billing'

const CompactSection = ({ title, expanded, onChange, children, name }) => {
  const values = hooks.useFieldValues([name])

  return (
    <Section name={name}>
      <Box>
        <Box
          onClick={onChange}
          sx={{
            display: 'flex',
            alignItems: 'center',
            p: .5,
            cursor: 'pointer',
            borderLeft: '3px solid',
            borderLeftColor: expanded ? 'primary.main' : 'transparent',
            backgroundColor: expanded ? 'action.selected' : 'transparent',
            '&:hover': {
              backgroundColor: expanded ? 'action.selected' : 'action.hover',
              borderLeftColor: 'primary.main',
            }
          }}
        >
          <Badge color='secondary' badgeContent={_.compact(values)?.length} variant='dot'>
            <Typography variant="body1" sx={{ color: expanded ? 'primary.main' : 'text.secondary', fontWeight: expanded ? 'bold' : 'normal' }}> {title}</Typography>
          </Badge>
          <Icon sx={{ color: expanded ? 'primary.main' : 'text.secondary' }}>expand_more</Icon>
        </Box>
        <Collapse in={expanded} timeout={150}>
          <Box sx={{ p: 2 }}>
            {children}
          </Box>
        </Collapse>
        {!expanded && <Divider sx={{ opacity: 0.3 }} />}
      </Box>
    </Section>
  )
}

const OrderForm = ({ mode, expandedSections: initialExpandedSections = ['quick'] }) => {
  const [expandedSections, setExpandedSections] = useState({
    quick: _.includes(initialExpandedSections, 'quick'),
    b2b: _.includes(initialExpandedSections, 'b2b'),
    transport: _.includes(initialExpandedSections, 'transport'),
    billing: _.includes(initialExpandedSections, 'billing')
  })

  const handleSectionChange = useCallback(section => () => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }))
  }, [setExpandedSections])

  return (
    <Box>
      <CompactSection
        title={I18n.t('order.search_section.quick')}
        expanded={expandedSections?.quick}
        onChange={handleSectionChange('quick')}
        name='quick'
      >
        <QuickSection mode={mode} />
      </CompactSection>

      <CompactSection
        title={I18n.t('order.search_section.b2b')}
        expanded={expandedSections?.b2b}
        onChange={handleSectionChange('b2b')}
        name='b2b'
      >
        <B2BSection />
      </CompactSection>

      <CompactSection
        title={I18n.t('order.search_section.transport')}
        expanded={expandedSections?.transport}
        onChange={handleSectionChange('transport')}
        name='transport'
      >
        <TransportSection mode={mode} />
      </CompactSection>

      <CompactSection
        title={I18n.t('order.search_section.billing')}
        expanded={expandedSections?.billing}
        onChange={handleSectionChange('billing')}
        name='billing'
      >
        <BillingSection mode={mode} />
      </CompactSection>
    </Box>
  )
}

export default React.memo(OrderForm)
